import * as React from "react";
import { useEffect, useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

const LINKS = [
  { id: "Results", no: "01", label: "実績" },
  { id: "About", no: "02", label: "私たちについて" },
  { id: "RoboCup", no: "03", label: "RoboCupとは" },
  { id: "Projects", no: "04", label: "開発体制" },
  { id: "Member", no: "05", label: "メンバー" },
  { id: "Location", no: "06", label: "活動拠点" },
  { id: "Partners", no: "07", label: "パートナー" },
];

const MOBILE_LINKS = [
  ...LINKS,
  { id: "Contact", no: "08", label: "お問い合わせ" },
];

function ResponsiveAppBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <nav className={"trps-nav" + (scrolled ? " trps-nav--scrolled" : "")}>
        <AnchorLink href="#Top" className="trps-nav__brand" offset={0}>
          <img src="/icon/orca_tight.svg" alt="TRAPS" />
        </AnchorLink>

        <div className="trps-nav__links">
          {LINKS.map((l) => (
            <AnchorLink key={l.id} href={`#${l.id}`} className="trps-navlink" offset={70}>
              {l.label}
            </AnchorLink>
          ))}
          <AnchorLink href="#Contact" className="trps-navlink trps-navlink--cta" offset={70}>
            お問い合わせ
          </AnchorLink>
        </div>

        <button
          className="trps-nav__burger"
          aria-label="メニューを開く"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "✕" : "☰"}
        </button>
      </nav>

      {open && (
        <div className="trps-nav__mobile" onClick={() => setOpen(false)}>
          {MOBILE_LINKS.map((l) => (
            <AnchorLink key={l.id} href={`#${l.id}`} offset={60} onClick={() => setOpen(false)}>
              <small>{l.no}</small>
              {l.label}
            </AnchorLink>
          ))}
        </div>
      )}
    </>
  );
}

export default ResponsiveAppBar;
